import AttachmentsList from '@app/components/AttachmentsList'
import PageSection from '@app/components/PageSection'
import PhotoStrip from '@app/components/PhotoStrip'
import { formatAddressSingleLine } from '@app/utils/formatting'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { DevelopmentSiteViewPageProps } from './DevelopmentSiteViewPage'

export default class DevelopmentSiteFiles extends React.PureComponent<
  DevelopmentSiteViewPageProps
> {
  public render() {
    return (
      <DocumentTitle
        title={`${this.props.site.client.name} :: ${formatAddressSingleLine(
          this.props.site.address,
        )} :: Files`}
      >
        <div className='mb-3'>
          <PageSection title='Photos'>
            <PhotoStrip photos={this.props.site.photos} />
          </PageSection>
          <PageSection title='Attachments'>
            <AttachmentsList
              attachments={this.props.site.attachments}
              onChange={this.props.setAttachments}
              className='mx-3'
            />
          </PageSection>
        </div>
      </DocumentTitle>
    )
  }
}
